export const facebookBlue = '#3b5998';
export const altBlue = '#374D7A';
export const facebookLightBlue = '#1877F2';
